import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Actions
import { gameActions } from '../../actions';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';

const Debrief = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game);
  const { id } = useParams();
  const { t } = useTranslation();

  React.useEffect(() => {
    if (id) {
      dispatch(gameActions.fetchGames(id));
    }
  }, [dispatch, id]);

  return (
    <div>
      <Header />

      <h2 className='mt-3 sec-title fs-3'>
        {t('Debrief')}
        <small className='float-end'>
          <DebriefMenu game_id={game.data._id} location={props.location} />
        </small>
      </h2>

      <div className='mt-3 pb-2 row'>
        <div className='col-12'>
          <div
            className='row flex-column bg-white mb-3 pt-5 pb-5'
            style={{
              minHeight: '78vh',
            }}>
            <div className='col-8 offset-2'>
              <p className='lead mt-1 text-center text-dark'>
                {t('overview_description')}
              </p>
            </div>

            <div className='col-10 offset-1 mt-5'>
              <div className='row'>
                <div className='col-4 mb-5'>
                  <div className='card h-100'>
                    <div className='card-body'>
                      <h5>Title</h5>
                      <p className='mt-3 mb-0 font-italic text-muted'>
                        Description...
                      </p>
                    </div>
                  </div>
                </div>

                <div className='col-4 mb-5'>
                  <div className='card h-100'>
                    <div className='card-body'>
                      <h5>Title</h5>
                      <p className='mt-3 mb-0 font-italic text-muted'>
                        Description...
                      </p>
                    </div>
                  </div>
                </div>

                <div className='col-4 mb-5'>
                  <div className='card h-100'>
                    <div className='card-body'>
                      <h5>Title</h5>
                      <p className='mt-3 mb-0 font-italic text-muted'>
                        Description...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Debrief as GameDebrief };
